import { useState } from 'react';
import {
    TextField,
    Box,
    Paper,
    Container,
    Typography,
    IconButton,
    InputAdornment,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { updatePasswordRequest } from '../remote/authRequest';
import { useLocation } from 'react-router-dom';
import PurpleButton from '../components/LayoutComponents/PurpleButton';
import Logo from '../components/LayoutComponents/Logo';
import Background from '../components/LayoutComponents/Background';
import theme from '../components/LayoutComponents/theme';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function ResetPassword({ user, isMobile }) {
    const [errors, setErrors] = useState({});
    const passwordRegex = /^(?=.*[A-Z])(?=.*[\W_]).{8,16}$/;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    const key = queryParams.get('key');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const isPasswordValid = (password) => {
        return passwordRegex.test(password);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'password') setPassword(value);
        if (name === 'confirmPassword') setConfirmPassword(value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const newErrors = validateForm();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            let res = await updatePasswordRequest(user?.email || email, password, key);
            if (res.status === 200) {
                alert('Password has been updated');
            }
        } catch (e) {
            alert(e);
        }
    };

    const validateForm = () => {
        let newErrors = {};
        if (!isPasswordValid(password)) newErrors.password = 'Password must be 8-16 characters long, include at least one uppercase letter, and one special character.';
        if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match.';
        return newErrors;
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    return (
        <Background>
            <Container
                component="main"
                sx={{
                    minHeight: "50vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pt: isMobile ? 2 : 8,

                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        width: "100%",
                        maxWidth: 380,
                        p: { xs: 2, sm: 3 },
                        boxSizing: "border-box",
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection:'column' }}>
                    <Logo />
                    <Typography variant='h5' sx={{ color: theme.colors.purple}}>Reset Password</Typography>
                    </Box>
                    <form onSubmit={handleSubmit}>
                        <Tooltip title="Password must be 8-16 characters long, include at least one uppercase letter, and one special character." arrow>
                            <Box mb={2}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Password"
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={password}
                                    onChange={handleChange}
                                    variant="outlined"
                                    error={!!errors.password}
                                    helperText={errors.password}
                                    size={isMobile ? "small" : "medium"}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip title="Password must match." arrow>
                            <Box mb={2}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Confirm Password"
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    value={confirmPassword}
                                    onChange={handleChange}
                                    variant="outlined"
                                    error={!!errors.confirmPassword}
                                    helperText={errors.confirmPassword}
                                    size={isMobile ? "small" : "medium"}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle confirm password visibility"
                                                    onClick={handleClickShowConfirmPassword}
                                                    edge="end"
                                                >
                                                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Tooltip>
                        <Box mt={2}>
                            <PurpleButton type="submit" label='Reset Password' fullWidth={isMobile} />
                        </Box>
                    </form>
                </Paper>
            </Container>
        </Background>
    );
}

export default ResetPassword;